import { shouldReduceMotion } from '@theme/utilities';

const TILT_MAX_DEGREES = 8;

/**
 * @param {HTMLElement} cardEl
 */
function initTiltEffect(cardEl) {
  if (shouldReduceMotion()) return;

  /** @type {number | null} */
  let frameId = null;

  /**
   * @param {number} rotateX
   * @param {number} rotateY
   */
  function applyTransform(rotateX, rotateY) {
    cardEl.style.transform = `perspective(50rem) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
  }

  /**
   * @param {MouseEvent} event
   */
  function handleMouseMove(event) {
    const rect = cardEl.getBoundingClientRect();
    const x = (event.clientX - rect.left) / rect.width - 0.5;
    const y = (event.clientY - rect.top) / rect.height - 0.5;

    if (frameId !== null) {
      cancelAnimationFrame(frameId);
    }

    frameId = requestAnimationFrame(() => {
      applyTransform(-y * TILT_MAX_DEGREES, x * TILT_MAX_DEGREES);
      frameId = null;
    });
  }

  function handleMouseLeave() {
    if (frameId !== null) {
      cancelAnimationFrame(frameId);
      frameId = null;
    }
    cardEl.style.transform = '';
  }

  cardEl.addEventListener('mousemove', handleMouseMove);
  cardEl.addEventListener('mouseleave', handleMouseLeave);
}

/**
 * @param {HTMLElement} sectionEl
 */
function initFeaturesHoverEffects(sectionEl) {
  if (sectionEl.dataset.hoverEffect !== 'tilt') return;

  sectionEl.querySelectorAll('.features-card').forEach((cardEl) => {
    if (cardEl instanceof HTMLElement) {
      initTiltEffect(cardEl);
    }
  });
}

document.querySelectorAll('[data-features]').forEach((sectionEl) => {
  if (sectionEl instanceof HTMLElement) {
    initFeaturesHoverEffects(sectionEl);
  }
});
